import { render, staticRenderFns } from "./BlockDisabled.vue?vue&type=template&id=3637880f&scoped=true&"
import script from "./BlockDisabled.vue?vue&type=script&lang=js&"
export * from "./BlockDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637880f",
  null
  
)

export default component.exports